import { useMediaQuery, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

type HeaderSubTitleProps = {
  label: string;
  colorTextSecondary?: boolean;
};

export const HeaderSubTitle = (props: HeaderSubTitleProps) => {
  const { label, colorTextSecondary = undefined } = props;
  const theme = useTheme();

  const isXS = useMediaQuery(theme.breakpoints.down('md'));
  const isMD = useMediaQuery(theme.breakpoints.down('xl'));

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const currentVariant = (isXS && 'caption') || (isMD && 'subtitle1') || 'h6';

  return (
    <Typography
      // variant={currentVariant}
      sx={{
        mb: 0.5,
        fontWeight: '500 !important',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '1rem',
        color: colorTextSecondary ? (thm) => thm.palette.text.secondary : undefined,
      }}
    >
      {label}
    </Typography>
  );
};
